<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Edit Parameters">
      <v-card-actions>
        <a @click="$router.back()">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1"
            class="mr-n2 mt-10" style="opacity:.6;">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component>
        <form autocomplete="off" @submit.prevent="save">
          <v-row>
            <v-col cols="12" md="12">
              <label class="font-weight-medium body-2">
                Parameter's
              </label>
              <div v-for="(n, i) of prmtr" :key="i">
                <v-card-component>
                  <v-row>
                    <v-col cols="12" md="11" class="pt-0 pb-0">
                      <v-row>
                        <v-col cols="12" md="2">
                          <label class="font-weight-medium body-2">
                            Position
                          </label>
                          <v-text-field title="Position" class="my-0 py-1" min="1" type="number"
                            placeholder="Position" v-model.trim="position" maxlength="100">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="5">
                          <label class="font-weight-medium body-2">
                            Parameter Name
                          </label>
                          <v-text-field class="my-0 py-1" counter="100" placeholder="Parameter name"
                            v-model.trim="parameterName" maxlength="100">
                          </v-text-field>
                        </v-col>
                        <!-- <v-col col="12" md="4">
                          <label class="font-weight-medium body-2">
                            Response Type
                          </label>
                          <v-autocomplete key="value" return-object label="Select Response"
                            :items="responseOptions" v-model="prmtr[i].responses" required
                            item-text="responseType"> </v-autocomplete>
                        </v-col> -->
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="1"
                      class="d-flex pt-0 pb-0 flex-column justify-center align-center">
                      <label class="font-weight-medium body-2">No. {{ i + 1 }}</label>

                      <v-card-actions>
                        <v-btn title="Delete parameter" elevation="1" color="error"
                          @click="deleteRow(i, prmtr[i])">
                          <v-icon left> mdi-trash-can </v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                </v-card-component>
              </div>
              <!-- <v-card-actions class="d-flex justify-end">
                <v-btn bottom right elevation="1" color="primary" @click="
                    prmtr.push({
                      auditSubCategoryID: subcategoryId,
          parameterName: '',
         // responses: '',
          position: '',
          isActive: true
                    })
                  ">
                  <v-icon left> mdi-plus </v-icon>
                  Add Parameter
                </v-btn>
              </v-card-actions> -->
            </v-col>

            <v-col cols="12">
              <v-card-actions class="d-flex justify-end">
                <v-btn bottom right elevation="1" color="primary" type="submit">
                  <v-icon left> mdi-content-save </v-icon>
                  Save
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </form>
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
// import { mapGetters } from 'vuex'
// import _ from 'lodash'
// import Utils from '@/utils'

import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'

export default {
  components: { VCardComponent, MaterialCard },
  props: ['parameterId'],
  data () {
    return {
      parameterName: '',
      selectedAcademicYear: '',
      position: 0,
      // showParam: false,
      // responseType: '',
      prmtr: [
        {
          id: this.parameterId,
          parameterName: ''
          // responses: '',
          //   position: '',
          //   isActive: true
        }
      ],

      isEdit: false,
      deleteParameters: []
    }
  },
  created: async function () {
    if (this.parameterId) {
      await this.getParameterDetails()
    }
  },
  watch: {},
  methods: {
    save: async function () {
      try {
        // await this.deleteMultipleParameters(this.deleteParameters)
        // let idz = _.map(this.classIds, c => c.id)
        // let final = this.classList.map(a => {
        //   return {
        //     classID: a.id,
        //     isActive: idz.includes(a.id)
        //   }
        // })

        // if (this.isEdit) {
        //   this.prmtr.map(a => {
        //     // delete a.id
        //     if (!a.id) {
        //       a.id = ''
        //     }
        //     delete a.categoryID
        //     return a
        //   })
        // }

        let formData = {
          id: this.parameterId,
          parameterName: this.parameterName
          // position: this.position,
          // isActive: true,
          // parameters: this.prmtr
          // response: this.response
          // parameters: _.map(this.prmtr, a => {
          //   a.responses = [a.responses]
          //   return a
          // })
        }
        console.log(formData, 'parameter')
        let res = await http.put(`${CONSTANTS.API_URL}/api/audit/audit-parameter/update/${this.parameterId}`, formData)
        console.log('res', res)
        this.$router.push({ name: 'generalParameterList' })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    getParameterDetails: async function () {
      try {
        let res = await http.get(`${CONSTANTS.API_URL}/api/audit/audit-parameter/getbyid/${this.parameterId}`)
        this.name = res.data.name
        this.position = res.data.position
        this.parameterName = res.data.parameterName
        // this.categoryName = res.data.categoryName
        // this.selectedAuditType = res.data.auditTypeID
        // this.selectedAcademicYear = res.data.academicYearID
        // this.subCategory = res.data.subCategory
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },

    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>

<style></style>
